import React from "react";

import DesktopNavigation from "./DesktopNavigation";
import MobileNavigation from "./MobileNavigation";
import "../../css/navigation.scss";

const Navigation = ({ currentLocation }) => (
  <div style={{ position: "sticky", top: 0, zIndex: 100 }}>
    <div id="desktop-nav-container">
      <DesktopNavigation currentLocation={currentLocation} />
    </div>
    <div id="mobile-nav-container">
      <MobileNavigation currentLocation={currentLocation} />
    </div>
  </div>
);

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.jsx